// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container.metrics-settings-page h1,
.container.metrics-settings-page h2 {
  margin-bottom: 15px;
}
.container.metrics-settings-page .details-header {
  margin-bottom: 20px;
}
.container.metrics-settings-page table {
  width: 30%;
}
.container.metrics-settings-page table tr td {
  padding: 1px;
  padding-left: 16px;
}
.container.metrics-settings-page table tr .btn-danger {
  font-size: 9px;
  padding: 3px 6px;
}
.container.metrics-settings-page .magview-button {
  background-color: #8D66C4;
}
.a-little-padding {
  padding: 3px;
}
.subtitle {
  font-size: 10px;
}
.tickets-page th {
  width: 4%;
}
.tickets-page medium {
  width: 8%;
}
.tickets-page .th-large {
  width: 22%;
}
.tickets-page .th-extra-large {
  width: 40%;
}
.notFromTeam {
  color: red;
}
.urgentNotFromTeam {
  color: darkred;
}
.urgent {
  background-color: #FFDCDC !important;
}
.normal {
  color: inherit;
}
.scoreBoard .config .glyphicon-cog {
  color: #595959;
  font-weight: lighter;
  font-size: 65px;
}
.dashboard-row {
  width: 100%;
  height: 38%;
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}
.details-container {
  display: flex;
  flex-wrap: wrap;
}
.metrics-buttons {
  position: absolute;
  right: 10px;
  top: 85px;
}
.info-card {
  display: flex;
  border: 2px solid #bcbcbc;
  flex-direction: column;
  margin: 2vw;
  flex: 1 1 25%;
  padding: 20px;
  background-color: #444;
  color: white;
  font-size: 20px;
}
.info-card * {
  margin-bottom: 20px;
}
.info-card span:first-child {
  font-weight: bold;
  font-size: 25px;
}
.tile {
  width: 19vw;
  height: 17vw;
  margin-left: 0.5vw;
  margin-right: 0.5vw;
  border: 2px solid #bcbcbc;
  border-radius: 3px;
}
.tile .header {
  margin: auto;
  height: 20%;
  padding: 2%;
  max-width: 15vw;
}
.tile .header label {
  font-weight: 400;
  font-size: 1.5vw;
}
.tile .content {
  height: 60%;
  margin: auto;
  text-align: center;
}
.tile .content label {
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 5.4vw;
}
.tile .content label .unit {
  font-size: 2.6vw;
}
.tile .trend {
  margin: auto;
  height: 20%;
  font-weight: normal;
  font-size: 1.2vw;
  height: 100%;
  width: 40%;
  text-align: right;
}
.config {
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.config .settings-container {
  display: flex;
  flex-direction: column;
  width: 45%;
  font-size: 18px;
}
.config .settings-container .config-row {
  width: 100%;
  margin: 14px 0;
  /*  * {
                display: block;
            }*/
}
.config .settings-container .config-row label {
  float: left;
  width: 25%;
}
.config .settings-container .config-row label span {
  width: 50%;
}
.config .settings-container .config-row label i {
  color: rgba(25, 0, 57, 0.89);
  padding-right: 1%;
  font-size: 35px;
}
.config .settings-container .config-row span {
  float: right;
  width: 30%;
  color: #8D66C4;
  text-align: end;
}
.config .settings-container .config-row span * {
  width: 100%;
}
.config .settings-container i {
  color: rgba(25, 0, 57, 0.89);
  padding-right: 1%;
  font-size: 20px;
}
button {
  border: 2px solid rgba(0, 0, 0, 0.1);
  line-height: 0.5;
  border-radius: 3px;
  text-align: center;
  padding: 10px 20px;
  font-size: 14px;
  color: #fff;
  padding-left: 10px;
  background-color: #8D66C4;
}
.right {
  float: right;
}
.section-header {
  display: flex;
}
.section-header i {
  color: rgba(25, 0, 57, 0.89);
  font-weight: 600;
  font-size: 26px;
}
.line {
  width: 100%;
  height: 0.5vh;
  float: left;
  border-radius: 3px;
}
.search-filters {
  display: flex;
  width: 110%;
  justify-content: flex-end;
}
.search-filters span {
  margin-left: 20px;
}
.searchTerm {
  font-weight: bold;
  margin: 0 -2.5px;
}
.preserve-whitespace {
  white-space: pre-wrap;
}
.searchBar {
  width: 630px;
  padding: 12px 20px;
  font-size: 24px;
  border: 1px solid #d0d8df;
  color: #1e1e1e;
  font-weight: 300;
}
.searchbar-container-sm .searchbar-sm {
  width: 500px;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid #d0d8df;
  color: #1e1e1e;
  font-weight: 400;
  border-radius: 4px;
}
.searchbar-container-sm .searchbutton-sm {
  color: white;
  width: unset;
  text-decoration: none;
  padding: 10px 14px;
  font-size: 16px;
  border: 2px solid #63a9be;
  font-weight: 400;
  border-radius: 4px;
}
.searchbar-container-sm .searchbutton-disabled-sm {
  color: white;
  width: unset;
  background-color: #cacaca;
  cursor: not-allowed;
  text-decoration: none;
  padding: 10px 14px;
  font-size: 16px;
  border: 2px solid #79798d;
  font-weight: 400;
  border-radius: 4px;
}
.fixed-table {
  table-layout: fixed;
}
:-ms-input-placeholder {
  opacity: 0.7;
}
::placeholder {
  opacity: 0.7;
}
/*************************************/
/*Page Consistency*/
* {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
h1 {
  margin: 0;
}
.main-table {
  background-color: #fff;
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: normal;
  color: #333333;
  padding: 5px;
}
.main-table th {
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  text-align: left;
  padding: 5px;
  border-top: medium none;
  background-color: #f0f0f0 !important;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  border-right: 1px solid #dddddd;
  border: 1px solid #ddd;
  line-height: 1.42857143;
  box-sizing: border-box;
  border-collapse: collapse;
  border-spacing: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.main-table th a {
  text-align: center;
  color: #333;
}
.main-table th a.cursor-pointer {
  cursor: pointer;
}
.main-table td {
  background-color: transparent;
  text-align: left;
  font-weight: normal;
  border-collapse: collapse;
  border-spacing: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-decoration: none;
  line-height: 1.42857143;
  border: 1px solid #ddd;
}
.main-table tr:nth-of-type(2n+1) {
  background-color: #f9f9f9;
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: #333333;
  line-height: 1.42857143;
}
.main-table .nested-table .note {
  background-color: inherit;
}
caption {
  font-size: 17px;
  font-weight: bold;
  color: #333;
  padding: 5px;
  border-top: medium none;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.42857143;
  box-sizing: border-box;
}
h2 {
  font-size: 17px;
  font-weight: bold;
  color: #333;
}
.date-header {
  margin-bottom: 18px;
}
.container-main {
  max-width: 99vw;
  margin: 0;
  background-color: white;
  padding: 10px;
}
/*Page Consistency*/
/*************************************/
/*************************************/
/*Agents view page*/
.agent-view-header {
  font-weight: 700;
}
.ticket-view-header {
  font-weight: 700;
  margin-bottom: 25px;
}
.agent-summary-info {
  display: flex;
  justify-content: space-between;
}
.buttonMenu {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.buttonMenu .agent-ticket-button {
  display: flex;
  color: white;
  background-color: #19a0ee;
  border: none;
  margin: 0 0 1vh 0;
  min-height: 30px;
  height: 5vh;
  width: 10vw;
  justify-content: space-between;
  align-items: center;
  padding: 0 18% 0 0;
  cursor: pointer;
}
.buttonMenu .agent-ticket-button .glyphicon {
  background-color: Highlight;
  line-height: 5vh;
  width: 5vh;
  text-align: center;
  top: 0;
}
.buttonMenu .agent-ticket-button span {
  flex: 1 1 auto;
  font-weight: bold;
  text-align: center;
}
.all-tickets-info {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  margin: 1vh 0 1.5vh 0;
}
.all-tickets-info h2 {
  margin: 0;
}
.all-tickets-info table {
  margin-top: 1vh;
  width: 20%;
}
.all-tickets-info td:nth-child(1) {
  text-align: left;
  font-weight: 400;
}
.all-tickets-info td:nth-child(2) {
  text-align: left;
  min-width: 80px;
  padding-left: 30px;
}
/*************************************/
.btn-generate {
  background-color: #8D66C4;
  border: 1px solid #1d0f29;
  width: 100%;
  color: white;
  border-radius: 3px;
  text-align: center;
  vertical-align: middle;
  padding: 6px 12px;
}
.btn-generate-disabled {
  background-color: #8d73af;
  border: 1px solid transparent;
}
.timeout-alert {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 15px;
  width: 95vw;
}
.table-hover tbody tr:hover td {
  background-color: aliceblue;
}
.table-hover tbody tr:hover .no-hover td {
  background-color: inherit;
}
.all-tickets-info {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
}
.all-tickets-info td {
  padding: 3px 0px;
}
.all-tickets-info td:nth-child(1) {
  font-weight: 400;
}
.all-tickets-info td:nth-child(2) {
  text-align: right;
  min-width: 80px;
  padding-left: 30px;
}
table.table-sectioned {
  table-layout: fixed;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  margin: 0 3px;
}
table.table-sectioned tbody.section {
  border-top: 2px solid rgba(0, 0, 0, 0.11);
}
table.table-sectioned tbody.section tr.section-row {
  background-color: rgba(10, 10, 10, 0.075);
}
table.table-sectioned tbody.section tr.hovered {
  background-color: azure;
}
table.table-sectioned tbody.section td,
table.table-sectioned tbody.section th {
  font-size: 12px;
  color: #000;
}
table.table-sectioned tbody.section th {
  background-color: #ebebeb;
  font-weight: unset;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: right;
}
table.table-sectioned tbody.section th a.cursor-pointer {
  cursor: pointer;
}
table.table-sectioned tbody.section td {
  background-color: unset;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: right;
}
table.table-sectioned tbody.section td.indented {
  padding-left: 7px;
}
table.table-sectioned tbody.section td.text-aligned-left {
  text-align: left;
}
table.table-sectioned tbody.section th.text-aligned-left {
  text-align: left;
}
table.table-sectioned tbody.section-empty {
  border-color: transparent;
  background-color: #f5f5f5;
}
table.table-sectioned tbody.section-empty tr {
  background-color: transparent;
}
table.table-sectioned tbody.section-empty th {
  background-color: transparent;
}
table.table-sectioned caption {
  text-align: center;
  padding: 0px 0px 5px 0px;
  font-size: small;
  color: #323232;
}
div.sectioned-table-holder {
  padding-left: 0.2vw;
  padding-right: 0.2vw;
}
div.container-full-width {
  width: 99vw;
  max-width: 99vw;
  background-color: white;
  border-radius: 3px;
  padding: 0.5vw 0.5vw;
  opacity: 1;
  margin-top: -25px;
}
.note {
  display: none;
  max-height: 4em;
  max-width: 80%;
  border-bottom: 1px solid #555;
}
.note td {
  text-wrap: none;
  white-space: normal;
  vertical-align: top;
  padding: 5px 0 5px 0;
}
.note td span {
  display: block;
}
.note:last-child {
  border-bottom: none;
}
.toggle-button {
  border: none;
  background: none;
  font-size: 12px;
  color: black;
  margin-left: 3vw;
}
.date-time-header {
  font-size: 15px;
  color: #505050;
  margin-right: 10px;
}
.main {
  display: flex;
}
.names-column {
  width: 10vw;
}
.top-values {
  margin-bottom: 30px;
}
.top-values::after {
  content: '';
  display: block;
  height: 12px;
  border: none;
}
.small-font {
  font-size: 9px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ticketAssignment/styles/ticketAssignment.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd;;cAEY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA,sCAAsC;AACtC,mBAAmB;AACnB;EACE,wEAAwE;AAC1E;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,wEAAwE;AAC1E;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,wEAAwE;EACxE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,aAAa;AACf;AACA,mBAAmB;AACnB,sCAAsC;AACtC,sCAAsC;AACtC,mBAAmB;AACnB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB","sourcesContent":[".container.metrics-settings-page h1,\n.container.metrics-settings-page h2 {\n  margin-bottom: 15px;\n}\n.container.metrics-settings-page .details-header {\n  margin-bottom: 20px;\n}\n.container.metrics-settings-page table {\n  width: 30%;\n}\n.container.metrics-settings-page table tr td {\n  padding: 1px;\n  padding-left: 16px;\n}\n.container.metrics-settings-page table tr .btn-danger {\n  font-size: 9px;\n  padding: 3px 6px;\n}\n.container.metrics-settings-page .magview-button {\n  background-color: #8D66C4;\n}\n.a-little-padding {\n  padding: 3px;\n}\n.subtitle {\n  font-size: 10px;\n}\n.tickets-page th {\n  width: 4%;\n}\n.tickets-page medium {\n  width: 8%;\n}\n.tickets-page .th-large {\n  width: 22%;\n}\n.tickets-page .th-extra-large {\n  width: 40%;\n}\n.notFromTeam {\n  color: red;\n}\n.urgentNotFromTeam {\n  color: darkred;\n}\n.urgent {\n  background-color: #FFDCDC !important;\n}\n.normal {\n  color: inherit;\n}\n.scoreBoard .config .glyphicon-cog {\n  color: #595959;\n  font-weight: lighter;\n  font-size: 65px;\n}\n.dashboard-row {\n  width: 100%;\n  height: 38%;\n  display: flex;\n  justify-content: space-around;\n  margin: 20px 0;\n}\n.details-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n.metrics-buttons {\n  position: absolute;\n  right: 10px;\n  top: 85px;\n}\n.info-card {\n  display: flex;\n  border: 2px solid #bcbcbc;\n  flex-direction: column;\n  margin: 2vw;\n  flex: 1 1 25%;\n  padding: 20px;\n  background-color: #444;\n  color: white;\n  font-size: 20px;\n}\n.info-card * {\n  margin-bottom: 20px;\n}\n.info-card span:first-child {\n  font-weight: bold;\n  font-size: 25px;\n}\n.tile {\n  width: 19vw;\n  height: 17vw;\n  margin-left: 0.5vw;\n  margin-right: 0.5vw;\n  border: 2px solid #bcbcbc;\n  border-radius: 3px;\n}\n.tile .header {\n  margin: auto;\n  height: 20%;\n  padding: 2%;\n  max-width: 15vw;\n}\n.tile .header label {\n  font-weight: 400;\n  font-size: 1.5vw;\n}\n.tile .content {\n  height: 60%;\n  margin: auto;\n  text-align: center;\n}\n.tile .content label {\n  letter-spacing: 1px;\n  font-weight: 400;\n  font-size: 5.4vw;\n}\n.tile .content label .unit {\n  font-size: 2.6vw;\n}\n.tile .trend {\n  margin: auto;\n  height: 20%;\n  font-weight: normal;\n  font-size: 1.2vw;\n  height: 100%;\n  width: 40%;\n  text-align: right;\n}\n.config {\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.config .settings-container {\n  display: flex;\n  flex-direction: column;\n  width: 45%;\n  font-size: 18px;\n}\n.config .settings-container .config-row {\n  width: 100%;\n  margin: 14px 0;\n  /*  * {\n                display: block;\n            }*/\n}\n.config .settings-container .config-row label {\n  float: left;\n  width: 25%;\n}\n.config .settings-container .config-row label span {\n  width: 50%;\n}\n.config .settings-container .config-row label i {\n  color: rgba(25, 0, 57, 0.89);\n  padding-right: 1%;\n  font-size: 35px;\n}\n.config .settings-container .config-row span {\n  float: right;\n  width: 30%;\n  color: #8D66C4;\n  text-align: end;\n}\n.config .settings-container .config-row span * {\n  width: 100%;\n}\n.config .settings-container i {\n  color: rgba(25, 0, 57, 0.89);\n  padding-right: 1%;\n  font-size: 20px;\n}\nbutton {\n  border: 2px solid rgba(0, 0, 0, 0.1);\n  line-height: 0.5;\n  border-radius: 3px;\n  text-align: center;\n  padding: 10px 20px;\n  font-size: 14px;\n  color: #fff;\n  padding-left: 10px;\n  background-color: #8D66C4;\n}\n.right {\n  float: right;\n}\n.section-header {\n  display: flex;\n}\n.section-header i {\n  color: rgba(25, 0, 57, 0.89);\n  font-weight: 600;\n  font-size: 26px;\n}\n.line {\n  width: 100%;\n  height: 0.5vh;\n  float: left;\n  border-radius: 3px;\n}\n.search-filters {\n  display: flex;\n  width: 110%;\n  justify-content: flex-end;\n}\n.search-filters span {\n  margin-left: 20px;\n}\n.searchTerm {\n  font-weight: bold;\n  margin: 0 -2.5px;\n}\n.preserve-whitespace {\n  white-space: pre-wrap;\n}\n.searchBar {\n  width: 630px;\n  padding: 12px 20px;\n  font-size: 24px;\n  border: 1px solid #d0d8df;\n  color: #1e1e1e;\n  font-weight: 300;\n}\n.searchbar-container-sm .searchbar-sm {\n  width: 500px;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid #d0d8df;\n  color: #1e1e1e;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.searchbar-container-sm .searchbutton-sm {\n  color: white;\n  width: unset;\n  text-decoration: none;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 2px solid #63a9be;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.searchbar-container-sm .searchbutton-disabled-sm {\n  color: white;\n  width: unset;\n  background-color: #cacaca;\n  cursor: not-allowed;\n  text-decoration: none;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 2px solid #79798d;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.fixed-table {\n  table-layout: fixed;\n}\n:-ms-input-placeholder {\n  opacity: 0.7;\n}\n::placeholder {\n  opacity: 0.7;\n}\n/*************************************/\n/*Page Consistency*/\n* {\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\nh1 {\n  margin: 0;\n}\n.main-table {\n  background-color: #fff;\n  width: 100%;\n  max-width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: normal;\n  color: #333333;\n  padding: 5px;\n}\n.main-table th {\n  font-weight: bold;\n  font-size: 14px;\n  color: #333333;\n  text-align: left;\n  padding: 5px;\n  border-top: medium none;\n  background-color: #f0f0f0 !important;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  border-right: 1px solid #dddddd;\n  border: 1px solid #ddd;\n  line-height: 1.42857143;\n  box-sizing: border-box;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.main-table th a {\n  text-align: center;\n  color: #333;\n}\n.main-table th a.cursor-pointer {\n  cursor: pointer;\n}\n.main-table td {\n  background-color: transparent;\n  text-align: left;\n  font-weight: normal;\n  border-collapse: collapse;\n  border-spacing: 0;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  text-decoration: none;\n  line-height: 1.42857143;\n  border: 1px solid #ddd;\n}\n.main-table tr:nth-of-type(2n+1) {\n  background-color: #f9f9f9;\n  width: 100%;\n  font-size: 14px;\n  font-weight: normal;\n  color: #333333;\n  line-height: 1.42857143;\n}\n.main-table .nested-table .note {\n  background-color: inherit;\n}\ncaption {\n  font-size: 17px;\n  font-weight: bold;\n  color: #333;\n  padding: 5px;\n  border-top: medium none;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 1.42857143;\n  box-sizing: border-box;\n}\nh2 {\n  font-size: 17px;\n  font-weight: bold;\n  color: #333;\n}\n.date-header {\n  margin-bottom: 18px;\n}\n.container-main {\n  max-width: 99vw;\n  margin: 0;\n  background-color: white;\n  padding: 10px;\n}\n/*Page Consistency*/\n/*************************************/\n/*************************************/\n/*Agents view page*/\n.agent-view-header {\n  font-weight: 700;\n}\n.ticket-view-header {\n  font-weight: 700;\n  margin-bottom: 25px;\n}\n.agent-summary-info {\n  display: flex;\n  justify-content: space-between;\n}\n.buttonMenu {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n}\n.buttonMenu .agent-ticket-button {\n  display: flex;\n  color: white;\n  background-color: #19a0ee;\n  border: none;\n  margin: 0 0 1vh 0;\n  min-height: 30px;\n  height: 5vh;\n  width: 10vw;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 18% 0 0;\n  cursor: pointer;\n}\n.buttonMenu .agent-ticket-button .glyphicon {\n  background-color: Highlight;\n  line-height: 5vh;\n  width: 5vh;\n  text-align: center;\n  top: 0;\n}\n.buttonMenu .agent-ticket-button span {\n  flex: 1 1 auto;\n  font-weight: bold;\n  text-align: center;\n}\n.all-tickets-info {\n  flex: 1 1 50%;\n  display: flex;\n  flex-direction: column;\n  margin: 1vh 0 1.5vh 0;\n}\n.all-tickets-info h2 {\n  margin: 0;\n}\n.all-tickets-info table {\n  margin-top: 1vh;\n  width: 20%;\n}\n.all-tickets-info td:nth-child(1) {\n  text-align: left;\n  font-weight: 400;\n}\n.all-tickets-info td:nth-child(2) {\n  text-align: left;\n  min-width: 80px;\n  padding-left: 30px;\n}\n/*************************************/\n.btn-generate {\n  background-color: #8D66C4;\n  border: 1px solid #1d0f29;\n  width: 100%;\n  color: white;\n  border-radius: 3px;\n  text-align: center;\n  vertical-align: middle;\n  padding: 6px 12px;\n}\n.btn-generate-disabled {\n  background-color: #8d73af;\n  border: 1px solid transparent;\n}\n.timeout-alert {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border-color: #faebcc;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  padding: 15px;\n  width: 95vw;\n}\n.table-hover tbody tr:hover td {\n  background-color: aliceblue;\n}\n.table-hover tbody tr:hover .no-hover td {\n  background-color: inherit;\n}\n.all-tickets-info {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n.all-tickets-info td {\n  padding: 3px 0px;\n}\n.all-tickets-info td:nth-child(1) {\n  font-weight: 400;\n}\n.all-tickets-info td:nth-child(2) {\n  text-align: right;\n  min-width: 80px;\n  padding-left: 30px;\n}\ntable.table-sectioned {\n  table-layout: fixed;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  margin: 0 3px;\n}\ntable.table-sectioned tbody.section {\n  border-top: 2px solid rgba(0, 0, 0, 0.11);\n}\ntable.table-sectioned tbody.section tr.section-row {\n  background-color: rgba(10, 10, 10, 0.075);\n}\ntable.table-sectioned tbody.section tr.hovered {\n  background-color: azure;\n}\ntable.table-sectioned tbody.section td,\ntable.table-sectioned tbody.section th {\n  font-size: 12px;\n  color: #000;\n}\ntable.table-sectioned tbody.section th {\n  background-color: #ebebeb;\n  font-weight: unset;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  text-align: right;\n}\ntable.table-sectioned tbody.section th a.cursor-pointer {\n  cursor: pointer;\n}\ntable.table-sectioned tbody.section td {\n  background-color: unset;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  text-align: right;\n}\ntable.table-sectioned tbody.section td.indented {\n  padding-left: 7px;\n}\ntable.table-sectioned tbody.section td.text-aligned-left {\n  text-align: left;\n}\ntable.table-sectioned tbody.section th.text-aligned-left {\n  text-align: left;\n}\ntable.table-sectioned tbody.section-empty {\n  border-color: transparent;\n  background-color: #f5f5f5;\n}\ntable.table-sectioned tbody.section-empty tr {\n  background-color: transparent;\n}\ntable.table-sectioned tbody.section-empty th {\n  background-color: transparent;\n}\ntable.table-sectioned caption {\n  text-align: center;\n  padding: 0px 0px 5px 0px;\n  font-size: small;\n  color: #323232;\n}\ndiv.sectioned-table-holder {\n  padding-left: 0.2vw;\n  padding-right: 0.2vw;\n}\ndiv.container-full-width {\n  width: 99vw;\n  max-width: 99vw;\n  background-color: white;\n  border-radius: 3px;\n  padding: 0.5vw 0.5vw;\n  opacity: 1;\n  margin-top: -25px;\n}\n.note {\n  display: none;\n  max-height: 4em;\n  max-width: 80%;\n  border-bottom: 1px solid #555;\n}\n.note td {\n  text-wrap: none;\n  white-space: normal;\n  vertical-align: top;\n  padding: 5px 0 5px 0;\n}\n.note td span {\n  display: block;\n}\n.note:last-child {\n  border-bottom: none;\n}\n.toggle-button {\n  border: none;\n  background: none;\n  font-size: 12px;\n  color: black;\n  margin-left: 3vw;\n}\n.date-time-header {\n  font-size: 15px;\n  color: #505050;\n  margin-right: 10px;\n}\n.main {\n  display: flex;\n}\n.names-column {\n  width: 10vw;\n}\n.top-values {\n  margin-bottom: 30px;\n}\n.top-values::after {\n  content: '';\n  display: block;\n  height: 12px;\n  border: none;\n}\n.small-font {\n  font-size: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
